import {
  saveAs
} from 'file-saver';
import * as pdfform from '../../node_modules/pdfform.js/pdfform.js';
import utilities from '../scripts/utilities';

let testForms = {
  gupTestForm: function (student, age, testDate) {
    let studentName = student.nameFirst + student.nameLast;

    var sourcePDFurl = '/testing_forms_pdfs/Gup_Testing_Form.pdf';

    var xhr = new XMLHttpRequest();
    xhr.open('GET', sourcePDFurl, true);
    xhr.responseType = 'arraybuffer';

    xhr.onload = function () {
      if (this.status == 200) {

        var rank = student.rank.substring(0, student.rank.indexOf(' '));
        var stateAbbrev = utilities.abbrState(student.state, 'abbr');

        var fields = {};
        fields['DateOfTest'] = [testDate];
        fields['FirstName'] = [student.nameFirst];
        fields['LastName'] = [student.nameLast];
        fields['Address'] = [student.address];
        fields['City'] = [student.city];
        fields['StateAbbrev'] = [stateAbbrev];
        fields['Zipcode'] = [student.zip];
        fields['FullName'] = [student.nameFirst + ' ' + student.nameLast];
        fields['DateOfEntrance'] = [student.startDate];
        fields['CurrentRank'] = [rank];
        fields['BeltSize'] = [student.beltSize];
        fields['DateOfLastPromotion'] = [student.lastTest];
        fields['DateOfBirth'] = [student.dob];
        fields['Phone'] = [student.phone];
        fields['Cellphone'] = [student.cellPhone];
        fields['EmergencyPhone'] = [student.emergencyPhone];
        fields['Email'] = [student.email];
        fields['ITFNumber'] = [student.ITFnumber];
        if (student.gender === "Male") {
          fields['Male'] = [true];
        } else {
          fields['Female'] = [true];
        }
        fields['Age'] = [age];

        var filledpdf = pdfform().transform(this.response, fields);
        var outBlob = new Blob([filledpdf], {
          type: 'application/pdf'
        });
        var fileName = studentName + '-TestingForm';

        saveAs(outBlob, fileName + '.pdf');
      } else {
        console.error('Could not retrieve PDF!');
      }
    };

    xhr.send();
  },
  pretestTestForm: function (student, age, testDate) {
    let studentName = student.nameFirst + student.nameLast;

    var sourcePDFurl = '/testing_forms_pdfs/Pretest_Testing_Form.pdf';

    var xhr = new XMLHttpRequest();
    xhr.open('GET', sourcePDFurl, true);
    xhr.responseType = 'arraybuffer';

    xhr.onload = function () {
      if (this.status == 200) {

        var rank = student.rank.substring(0, student.rank.indexOf(' '));
        var stateAbbrev = utilities.abbrState(student.state, 'abbr');

        var fields = {};
        fields['DateOfTest'] = [testDate];
        fields['FirstName'] = [student.nameFirst];
        fields['LastName'] = [student.nameLast];
        fields['Address'] = [student.address];
        fields['City'] = [student.city];
        fields['StateAbbrev'] = [stateAbbrev];
        fields['Zipcode'] = [student.zip];
        fields['FullName'] = [student.nameFirst + ' ' + student.nameLast];
        fields['DateOfEntrance'] = [student.startDate];
        fields['CurrentRank'] = [rank];
        fields['PreTestNumber'] = [student.testNumber];
        fields['DateOfLastPromotion'] = [student.lastTest];
        fields['DateOfBirth'] = [student.dob];
        fields['Phone'] = [student.phone];
        fields['Cellphone'] = [student.cellPhone];
        fields['EmergencyPhone'] = [student.emergencyPhone];
        fields['Email'] = [student.email];
        fields['ITFNumber'] = [student.ITFnumber];
        if (student.gender === "Male") {
          fields['Male'] = [true];
        } else {
          fields['Female'] = [true];
        }
        fields['Age'] = [age];

        var filledpdf = pdfform().transform(this.response, fields);
        var outBlob = new Blob([filledpdf], {
          type: 'application/pdf'
        });
        var fileName = studentName + '-TestingForm';

        saveAs(outBlob, fileName + '.pdf');
      } else {
        console.error('Could not retrieve PDF!');
      }
    }

    xhr.send();
  },
  danTestForm: function (student, age, testDate) {
    let studentName = student.nameFirst + student.nameLast;

    var sourcePDFurl = '/testing_forms_pdfs/Dan_Testing_Form.pdf';

    var xhr = new XMLHttpRequest();
    xhr.open('GET', sourcePDFurl, true);
    xhr.responseType = 'arraybuffer';

    xhr.onload = function () {
      if (this.status == 200) {

        var rank = student.rank.substring(0, student.rank.indexOf('-'));
        var stateAbbrev = utilities.abbrState(student.state, 'abbr');

        var fields = {};
        fields['DateOfTest'] = [testDate];
        fields['FirstName'] = [student.nameFirst];
        fields['LastName'] = [student.nameLast];
        fields['Address'] = [student.address];
        fields['City'] = [student.city];
        fields['StateAbbrev'] = [stateAbbrev];
        fields['Zipcode'] = [student.zip];
        fields['FullName'] = [student.nameFirst + ' ' + student.nameLast];
        fields['DateOfEntrance'] = [student.startDate];
        fields['CurrentRank'] = [rank];
        fields['BeltSize'] = [student.beltSize];
        fields['DateOfLastPromotion'] = [student.lastTest];
        fields['DateOfBirth'] = [student.dob];
        fields['Phone'] = [student.phone];
        fields['Cellphone'] = [student.cellPhone];
        fields['EmergencyPhone'] = [student.emergencyPhone];
        fields['Email'] = [student.email];
        fields['ITFNumber'] = [student.ITFnumber];
        if (student.gender === "Male") {
          fields['Male'] = [true];
        } else {
          fields['Female'] = [true];
        }
        fields['Age'] = [age];

        var filledpdf = pdfform().transform(this.response, fields);
        var outBlob = new Blob([filledpdf], {
          type: 'application/pdf'
        });
        var fileName = studentName + '-TestingForm';

        saveAs(outBlob, fileName + '.pdf');
      } else {
        console.error('Could not retrieve PDF!');
      }
    }

    xhr.send();
  },
  danRecertForm: function (student, age, testDate) {
    let studentName = student.nameFirst + student.nameLast;

    var sourcePDFurl = '/testing_forms_pdfs/Dan_Recert_Form.pdf';

    var xhr = new XMLHttpRequest();
    xhr.open('GET', sourcePDFurl, true);
    xhr.responseType = 'arraybuffer';

    xhr.onload = function () {
      if (this.status == 200) {

        var rank = student.rank.substring(0, student.rank.indexOf('-'));
        var stateAbbrev = utilities.abbrState(student.state, 'abbr');

        var fields = {};
        fields['DateOfTest'] = [testDate];
        fields['FirstName'] = [student.nameFirst];
        fields['LastName'] = [student.nameLast];
        fields['Address'] = [student.address];
        fields['City'] = [student.city];
        fields['StateAbbrev'] = [stateAbbrev];
        fields['Zipcode'] = [student.zip];
        fields['FullName'] = [student.nameFirst + ' ' + student.nameLast];
        fields['DateOfEntrance'] = [student.startDate];
        fields['CurrentRank'] = [rank];
        fields['RecertificationNumber'] = [student.testNumber];
        fields['DateOfLastPromotion'] = [student.lastTest];
        fields['DateOfBirth'] = [student.dob];
        fields['Phone'] = [student.phone];
        fields['Cellphone'] = [student.cellPhone];
        fields['EmergencyPhone'] = [student.emergencyPhone];
        fields['Email'] = [student.email];
        fields['ITFNumber'] = [student.ITFnumber];
        if (student.gender === "Male") {
          fields['Male'] = [true];
        } else {
          fields['Female'] = [true];
        }
        fields['Age'] = [age];

        var filledpdf = pdfform().transform(this.response, fields);
        var outBlob = new Blob([filledpdf], {
          type: 'application/pdf'
        });
        var fileName = studentName + '-TestingForm';

        saveAs(outBlob, fileName + '.pdf');
      } else {
        console.error('Could not retrieve PDF!');
      }
    }

    xhr.send();
  }
};

export default testForms;